<template>
  <div v-if="!props.isNodata && showCategoryOptionsYn" class="c-line-black-box">
    <!-- D: PC에만 노출 -->
    <div class="c-use-table type-search only-pc">
      <table>
        <caption>
          검색 옵션 선택 테이블
        </caption>
        <colgroup>
          <col style="width: 17.937%" />
          <col />
        </colgroup>
        <tbody>

          <SearchCategoryRow
              v-if="lvl2Categories"
              :category-name="'시장'"
              v-model:categories="lvl2Categories"
              @select-changed="() => emits('selectChanged')"
            />
            <SearchCategoryRow
              v-if="lvl3Categories"
              :category-name="'브랜드'"
              v-model:categories="lvl3Categories"
              @select-changed="() => emits('selectChanged')"
            />
            <SearchCategoryRow
              v-if="lvl4Categories"
              :category-name="'제품군'"
              v-model:categories="lvl4Categories"
              @select-changed="() => emits('selectChanged')"
            />
          <!-- <SearchCategoryRow
            :category-name="'제품규격'"
            v-model:categories="totalQtyCategories"
            @select-changed="() => emits('selectChanged')"
          />
          <SearchCategoryRow
            :category-name="'SET/개별제품'"
            v-model:categories="setgdYnCategories"
            @select-changed="() => emits('selectChanged')"
          /> -->
        </tbody>
      </table>
    </div>
    <!-- // D: PC에만 노출 -->

    <!-- D: MO에만 노출 -->
    <div class="mo-filter-wrap only-mo">
      <div class="filter-items">
        <button
          v-for="item in mobileSelectedCategories"
          :key="item.clsfCd"
          type="button"
          class="filter-item"
        >
          <span
            >{{ item.clsfNm }}({{ Utils.currency(item.productCount) }})</span
          >
        </button>
      </div>
      <button
        type="button"
        class="btn-filter"
        @click="() => (isShowMobileFilterPop = true)"
      >
        <span class="sr-only">필터설정</span>
      </button>
    </div>
    <!-- //  D: MO에만 노출 -->
  </div>

  <SearchCategorySelectedItems
    v-if="!props.isNodata"
    :selected-categories="selectedCategories"
    @unset-all="unsetAll"
    @select-changed="() => emits('selectChanged')"
  />

  <MobileFilterPop
    v-if="isShowMobileFilterPop && searchCategories"
    :search-categories="searchCategories"
    :searchParams="props.searchParams"
    @close="() => (isShowMobileFilterPop = false)"
    @categories-selected="onMobileCategoriesSelected"
  />

  <!-- D: 데이터가 존재하지 않은 경우 -->
  <div v-if="props.isNodata" class="c-no-data-box">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <div class="text">
      <p>
        해당 검색어로 검색된 결과가 <br class="only-mo" />존재하지 않습니다.
      </p>
      <p class="sub-text">검색어가 올바르게 입력되었는지 확인해주세요.</p>
    </div>
  </div>
</template>
<script setup>
import {
  onMounted,
  defineModel,
  computed,
  defineEmits,
  ref,
  defineProps,
  watch,
  nextTick,
} from "vue";
import SearchCategoryRow from "@/components/paintpro/prod/searchCategoryRow.vue";
import SearchCategorySelectedItems from "@/components/paintpro/prod/searchCategorySelectedItems.vue";
import MobileFilterPop from "@/components/paintpro/prod/moSearchFilterPop.vue";
import Utils from "@/js/utils";

const emits = defineEmits(["selectChanged"]);

const props = defineProps({
  isNodata: {
    type: Boolean,
    default: false,
  },
  searchParams: {
    type: Object,
    required: true,
  }
});

const searchCategories = defineModel("searchCategories", { required: true });
const isShowMobileFilterPop = ref(false);

const showCategoryOptionsYn = ref(true);

onMounted(() => {});

const lvl2Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl2Categories;
});

const lvl3Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl3Categories;
});

const lvl4Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl4Categories;
});

// const totalQtyCategories = computed(() => {
//   if (!searchCategories.value) return [];

//   return searchCategories.value.totalQtyCategories;
// });

// const setgdYnCategories = computed(() => {
//   if (!searchCategories.value) return [];

//   return searchCategories.value.setgdYnCategories;
// });

const selectedCategories = computed(() => {
  if (!searchCategories.value) return [];

  return [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
    //...searchCategories.value.totalQtyCategories,
    //...searchCategories.value.setgdYnCategories,
  ].filter((item) => item.selected === true);
});

const mobileSelectedCategories = computed(() => {
  if (!searchCategories.value) return [];

  return [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
    //...searchCategories.value.totalQtyCategories,
    //...searchCategories.value.setgdYnCategories,
  ].filter((item) => item.selected === true);
});

watch(searchCategories, () => {
  reRenderShowCategoryOptionsYn();
});

const unsetAll = () => {
  [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
    //...searchCategories.value.totalQtyCategories,
    //...searchCategories.value.setgdYnCategories,
  ].forEach((item) => (item.selected = false));

  emits("selectChanged");
};

const onMobileCategoriesSelected = (newCategories) => {
  searchCategories.value = newCategories;
  isShowMobileFilterPop.value = false;

  emits("selectChanged");
};

const reRenderShowCategoryOptionsYn = () => {
  showCategoryOptionsYn.value = false;
  nextTick(() => {
    showCategoryOptionsYn.value = true;
  });
};
</script>
